import { render, staticRenderFns } from "./IndexCard.vue?vue&type=template&id=d962ec76&"
import script from "./IndexCard.vue?vue&type=script&lang=js&"
export * from "./IndexCard.vue?vue&type=script&lang=js&"
import style0 from "./IndexCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib'
installComponents(component, {VContent})
